// extracted by css-extract-rspack-plugin
export default {"EmptyStateRoot":"ZL3uT"};